/**
 * Parse clipboard text pasted from Excel / Google Sheets into a 2D array.
 * Excel uses `\t` (tab) between cells and `\r\n` or `\n` between rows.
 * Strips a trailing empty row that Excel often emits.
 *
 * Returns: { rows: string[][], hasHeader: boolean }
 */
const HEADER_TOKENS = new Set([
  "main_category", "main category", "main", "category",
  "sub_category", "sub category", "sub", "subcategory",
  "issue_type", "issue type", "issue", "type",
  "department", "dept",
  "case_type", "case type", "case",
  "priority", "pri",
  "sla_minutes", "sla", "sla minutes", "sla (min)",
  "branch_required", "branch", "branch required", "branch req",
]);

export function parsePastedTable(text) {
  const normalised = (text || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const lines = normalised.split("\n");
  // Drop trailing empties Excel appends
  while (lines.length && lines[lines.length - 1].trim() === "") lines.pop();
  const rows = lines.map((line) => line.split("\t"));
  let hasHeader = false;
  if (rows.length) {
    const first = rows[0].map((c) => (c || "").trim().toLowerCase());
    const headerHits = first.filter((c) => HEADER_TOKENS.has(c)).length;
    hasHeader = headerHits >= 2;
  }
  return { rows, hasHeader };
}

const PRIORITY_MAP = { low: "low", medium: "medium", high: "high", critical: "critical", med: "medium", crit: "critical" };

/**
 * Coerce a single pasted cell value to the target column's expected shape.
 * Returns the string the grid should display in that cell (no validation here —
 * validation runs on blur + on the Validate button).
 */
export function coerceCellValue(column, raw) {
  const v = (raw || "").trim();
  if (column === "priority") {
    const k = v.toLowerCase();
    return PRIORITY_MAP[k] || v;
  }
  if (column === "branch_required") {
    const s = v.toLowerCase();
    if (["true", "yes", "y", "1"].includes(s)) return "true";
    if (["false", "no", "n", "0", ""].includes(s)) return "false";
    return v;
  }
  return v;
}
